import React, { useState, useEffect } from "react";
import { Box, Autocomplete, TextField, Snackbar, IconButton, Alert } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { OfficeLocationFilter, ProgramFilter, ReportFilterBar } from "../ReportFilters";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import ControlledDataGrid from '../../DataGrid/ControlledDataGrid';
import DefaultToolbar from "../../DataGrid/DefaultToolbar";
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";
import dayjs from "dayjs";

const shortcutsItems = [
    {
        label: 'This Week',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('week'), today.endOf('week')];
        },
    },
    {
        label: 'Last Week',
        getValue: () => {
            const today = dayjs();
            const prevWeek = today.subtract(7, 'day');
            return [prevWeek.startOf('week'), prevWeek.endOf('week')];
        },
    },
    {
        label: 'Last 7 Days',
        getValue: () => {
            const today = dayjs();
            return [today.subtract(7, 'day'), today];
        },
    },
    {
        label: 'Current Month',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('month'), today.endOf('month')];
        },
    },
    {
        label: 'Last Month',
        getValue: () => {
            const today = dayjs();
            const lastMonth = today.subtract(1, 'month');
            return [lastMonth.startOf('month'), lastMonth.endOf('month')];
        },
    },
];

export default function SessionsReport(props) {
    // const [gridId, setGridId] = useState(73);
    // const apiRef = useGridApiRef();

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [companyFilter, setCompanyFilter] = useState({
        dateRange: [
            moment().startOf("month").format("YYYY-MM-DD"),
            moment().endOf("month").format("YYYY-MM-DD"),
        ],
    });
    const [selectedOffice, setSelectedOffice] = useState(null);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [reportDetails, setReportDetails] = useState({});
    const [isFavorite, setIsFavorite] = useState(false);
    const [successText, setSuccessText] = useState("");
    const [errorText, setErrorText] = useState("");

    const getPresetRange = (preset) => {
        switch (preset) {
            case "this_week":
                return [
                    moment().startOf("week").format("YYYY-MM-DD"),
                    moment().endOf("week").format("YYYY-MM-DD"),
                ];
            case "last_week":
                return [
                    moment().subtract(1, "week").startOf("week").format("YYYY-MM-DD"),
                    moment().subtract(1, "week").endOf("week").format("YYYY-MM-DD"),
                ];
            case "this_month":
                return [
                    moment().startOf("month").format("YYYY-MM-DD"),
                    moment().endOf("month").format("YYYY-MM-DD"),
                ];
            case "last_month":
                return [
                    moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
                    moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                ];
            default:
                return null;
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        // axios
        //     .get(APIURL + "/jsreport/getAllReports", {
        //         params: { empID: props.user.emp_id },
        //     })
        //     .then((response) => {
        //         const report = response?.data?.reports.find((ele) => ele.report_name === "Employee Sessions Report");
        //         setReportDetails(report);
        //         setIsFavorite(report ? (report.status === 1 ? true : false) : false);
        //     });

        axios
            .get(APIURL + "/reports/getSessions", {
                params: {
                    compID: props.user.comp_id,
                    empID: props.user.emp_id,
                    empType: props.user.type,
                    start: moment(companyFilter?.dateRange[0]).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
                    end: moment(companyFilter?.dateRange[1]).endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
                    oloc_id: selectedOffice || undefined,
                    program_id: selectedProgram || undefined,
                },
            })
            .then((response) => {
                let sessionData = response?.data.length !== 0 ? response?.data : [];
                setData(sessionData);
            })
            .catch((err) => {
                console.log(err);
            });

        setIsLoading(false);
    };

    let rows = data.map((data, idx) => {
        let taskData = {
            id: idx,
            schedule_id: data.schedule_id,
            schedule_name: data.schedule_name,
            task_type: data.task_type,
            start_time: moment(data.start_time).format('MM/DD/YYYY hh:mm A'),
            end_time: moment(data.end_time).format('MM/DD/YYYY hh:mm A'),
            attendees: data.Attendees ? data.Attendees.map((attendee) => attendee.cus_name).join(", ") : '-'
        };
        return taskData;
    });

    const columns = [
        { field: "id", headerName: "ID", hide: true },
        { field: "schedule_id", headerName: "Schedule ID", hide: true },
        { field: "schedule_name", headerName: "Session Name", width: 200 },
        { field: "attendees", headerName: "Attendees", width: 200 },
        { field: "task_type", headerName: "Session Task Type", width: 150 },
        { field: "start_time", headerName: "Session Start Time", width: 200 },
        { field: "end_time", headerName: "Session End Time", width: 200 },
    ]

    const markFavourite = async (data, type) => {
        const payload = {
            report_id: data?.report_id,
            status: type,
            empID: props.user.emp_id
        };

        axios
            .put(APIURL + "/jsreport/markFavorite", payload)
            .then((response) => {
                if (response?.status === 200 && response?.data?.code === 200) {
                    setSuccessText(response?.data?.status_message || "Favorite Modifed Succesfully");
                } else {
                    setErrorText("Something went wrong");
                }

                fetchData();
            });
    }

    return (
        <div style={{ width: '100%', padding: 10 }}>
            <div style={{ display: 'flex', marginBottom: 10, justifyContent: 'space-between' }}>
                <ReportFilterBar onSearch={() => fetchData()} style={{ flexWrap: 'wrap', rowGap: 10 }}>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        localeText={{ start: "From Date", end: "To Date" }}
                    >
                        <DateRangePicker
                            label='Date Range'
                            value={[
                                dayjs(companyFilter?.dateRange[0]),
                                dayjs(companyFilter?.dateRange[1])
                            ]}
                            onChange={(newValue) => {
                                setCompanyFilter({
                                    ...companyFilter,
                                    dateRange: [
                                        dayjs(newValue[0]).format("YYYY-MM-DD"),
                                        dayjs(newValue[1]).format("YYYY-MM-DD"),
                                    ],
                                });
                            }}
                            slotProps={{
                                shortcuts: {
                                    items: shortcutsItems,
                                },
                                textField: { size: 'small', style: { width: 275 } }
                            }}
                        />
                    </LocalizationProvider>

                    <OfficeLocationFilter
                        comp_id={props.user.comp_id}
                        value={selectedOffice}
                        onChange={setSelectedOffice}
                    />

                    <ProgramFilter
                        comp_id={props.user.comp_id}
                        value={selectedProgram}
                        onChange={setSelectedProgram}
                    />
                </ReportFilterBar>

                {/* <div>
                    <Tooltip title={isFavorite ? "Remove from favorite reports" : "Add to favorite reports"}>
                        <img
                            src={isFavorite ? "./star-solid.svg" : "./star-regular.svg"}
                            alt="barchart"
                            style={{
                                fontFamily: "Lato",
                                width: "1.5rem",
                                height: "1.5rem",
                                cursor: "pointer",
                                margin: 5
                            }}
                            onClick={() => markFavourite(reportDetails, isFavorite ? 0 : 1)}
                        />
                    </Tooltip>
                </div> */}
            </div>
            <div style={{ height: 'calc(100vh - 250px)' }}>
                <DataGridPro
                    // gridId={gridId}
                    // user={props.user}
                    initialState={{ sorting: { sortModel: [{ field: "schedule_id", sort: "desc" }] } }}
                    // apiRef={apiRef}
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    showToolbar
                    slots={{
                        toolbar: DefaultToolbar,
                    }}
                />
            </div>
            <Snackbar
                open={successText !== ""}
                autoHideDuration={30000}
                onClose={() => setSuccessText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"success"}
                    elevation={6}
                    variant="filled"
                >
                    {successText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setSuccessText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
            <Snackbar
                open={errorText !== ""}
                autoHideDuration={30000}
                onClose={() => setErrorText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"error"}
                    elevation={6}
                    variant="filled"
                >
                    {errorText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setErrorText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
        </div>
    );
}